
import { 
  SidebarFooter as UIFooter,
} from "@/components/ui/sidebar";
import { useAuth } from "@/context/AuthContext";
import { LogOut } from "lucide-react";
import { toast } from "sonner";
import { useState } from "react";
import { Button } from "@/components/ui/button";

export function SidebarFooter() {
  const { logout } = useAuth();
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  
  const handleLogout = async (e: React.MouseEvent) => {
    e.preventDefault();
    setIsLoggingOut(true);
    
    try {
      console.log("SidebarFooter: Logout clicked");
      await logout();
      // Navigation is handled in the logout function
    } catch (error) {
      console.error("SidebarFooter logout error:", error);
      toast.error("Failed to sign out, please try refreshing the page");
    } finally {
      setIsLoggingOut(false);
    }
  };
  
  return (
    <UIFooter className="border-t border-gray-800 p-4">
      <Button 
        onClick={handleLogout} 
        disabled={isLoggingOut}
        className="text-sm text-gray-400 hover:text-white transition-colors w-full text-left flex items-center gap-2"
        variant="ghost"
        type="button"
      >
        {isLoggingOut ? (
          <>
            <span className="w-4 h-4 border-2 border-gray-400 border-t-transparent rounded-full animate-spin"></span>
            Signing out...
          </>
        ) : (
          <>
            <LogOut className="w-4 h-4" />
            Sign out
          </>
        )}
      </Button>
    </UIFooter>
  );
}
